<template>
  <div>
    <report-va :base_info="base_info"></report-va>
  </div>
</template>
<script>
import reportVa from "./ReportVaWithRecord.vue";

export default {
  name: "MyReportWithRecord",
  components: {
    reportVa
  },
  data() {
    return {
      base_info: {
        title_ch: "我的报告(含原始记录)",
        post_url: "/ask_list_data",
        askData: "myReportList"
      },
    };
  },
  watch: {},
  computed: {},
  methods: {}
};
</script>
<style scoped>
</style>
